"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
//* Returns text displayed in UI */
function ComboBoxInput(_a) {
    var id = _a.id, inputRef = _a.inputRef, placeholder = _a.placeholder, ariaLabel = _a.ariaLabel, name = _a.name, comboBoxType = _a.comboBoxType, readOnly = _a.readOnly, value = _a.value, selectedValues = _a.selectedValues, renderValuesAsTags = _a.renderValuesAsTags, onClearTagFocus = _a.onClearTagFocus, onFreeTextChangeQuery = _a.onFreeTextChangeQuery, renderInputContent = _a.renderInputContent, getOptionText = _a.getOptionText;
    var freeText = comboBoxType === 'single-freetext' || comboBoxType === 'multiple-freetext';
    var multiple = comboBoxType === 'multiple' ||
        comboBoxType === 'multiple-freetext' ||
        comboBoxType === 'multiple-searchable';
    var getValue = function () {
        var selectedVal = selectedValues && selectedValues.length > 0
            ? (selectedValues[0].initialObj || selectedValues[0])
            : undefined;
        if (comboBoxType === 'single-freetext' && selectedValues && selectedValues.length > 0) {
            return renderInputContent(selectedVal, getOptionText(selectedVal));
        }
        if (comboBoxType === 'single-freetext' || comboBoxType === 'multiple-freetext') {
            return undefined;
        }
        if (!multiple) {
            // Return single value
            if (selectedValues && selectedValues.length > 0) {
                return renderInputContent(selectedVal, getOptionText(selectedVal));
            }
            return '';
        }
        if (!renderValuesAsTags) {
            var names = selectedValues.map(function (option) {
                return renderInputContent((option.initialObj || option), getOptionText((option.initialObj || option)));
            });
            if (names.length) {
                return names.join(', ');
            }
        }
        return '';
    };
    var inputValue = value !== undefined || !freeText ? getValue() : undefined;
    var defaultInputValue = value === undefined && freeText ? getValue() : undefined;
    if (freeText && !multiple && value !== undefined && getValue() === undefined) {
        inputValue = '';
    }
    return (react_1.default.createElement("input", { id: id, "aria-invalid": "false", autoComplete: "off", ref: inputRef, placeholder: placeholder, type: "text", name: name, "aria-label": ariaLabel, readOnly: !freeText || readOnly, "aria-autocomplete": "list", autoCapitalize: "none", spellCheck: "false", value: inputValue, defaultValue: defaultInputValue, onFocus: function () {
            if (freeText) {
                onClearTagFocus();
            }
        }, onChange: function (e) {
            var _a;
            if (freeText) {
                var hasTag = !!(selectedValues && ((_a = selectedValues) === null || _a === void 0 ? void 0 : _a.length));
                var showClearButton = e.target.value.length > 0 || hasTag;
                onFreeTextChangeQuery({
                    event: e,
                    showClearButton: showClearButton
                });
            }
        } }));
}
exports.default = ComboBoxInput;
